import React from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProjectsGrid.css';
import BinnFarmImage from '../../images/Projects/Binn-Eco-Park-scaled.jpg';
import NorthKyleImage from '../../images/Projects/NorthKyleWindfarm.jpg';
import BenbrackWindFarmImage from '../../images/Projects/Benbrack_Wind_Farm.png';
import ClashindarrochIIImage from '../../images/Projects/Clashindarroch_II_Wind_Farm.png';
import CloicheWindFarmImage from '../../images/Projects/Cloiche_Wind_Farm.png';
import SandyKnoweImage from '../../images/Projects/SandyKnowe_Wind_Farm.png';
import ScapaDeepWaterQuayImage from '../../images/Projects/Scapa_Deep_Water_Quay.png';
import { useInView } from 'react-intersection-observer';

export const projectsData = [
  {
    id: 'binn-farm-efw-facility',
    titleKey: 'projectsGrid.binnFarmTitle',
    descriptionKey: 'projectsGrid.binnFarmDescription',
    projectDescriptionKey: 'projectsGrid.binnFarmProjectDescription',
    image: BinnFarmImage,
    valueKey: 'projectsGrid.binnFarmValue',
    client: 'Paprec Engineering CNIM',
    FOC: 'FIDIC Red Book 2017'
  },
  {
    id: 'north-kyle-windfarm',
    titleKey: 'projectsGrid.northKyleTitle',
    descriptionKey: 'projectsGrid.northKyleDescription',
    projectDescriptionKey: 'projectsGrid.northKyleProjectDescription',
    image: NorthKyleImage,
    valueKey: 'projectsGrid.northKyleValue',
    client: 'Brockwell Energy',
    FOC: 'FIDIC Yellow Book 1999'
  },
  {
    id: 'benbrack-wind-farm',
    titleKey: 'projectsGrid.benbrackTitle',
    descriptionKey: 'projectsGrid.benbrackDescription',
    projectDescriptionKey: 'projectsGrid.benbrackProjectDescription',
    image: BenbrackWindFarmImage,
    valueKey: 'projectsGrid.benbrackValue',
    client: 'Red Rock Renewables',
    FOC: 'FIDIC Yellow Book 1999',
    servicesKey: 'projectsGrid.benbrackServices'
  },
  {
    id: 'sandyknowe-wind-farm',
    titleKey: 'projectsGrid.sandyknoweTitle',
    descriptionKey: 'projectsGrid.sandyknoweDescription',
    projectDescriptionKey: 'projectsGrid.sandyknoweProjectDescription',
    image: SandyKnoweImage,
    valueKey: 'projectsGrid.sandyknoweValue',
    client: 'ERG',
    FOC: 'FIDIC Yellow Book 1999',
    servicesKey: 'projectsGrid.sandyknoweServices'
  },
  {
    id: 'scapa-deep-water-quay',
    titleKey: 'projectsGrid.scapaTitle',
    descriptionKey: 'projectsGrid.scapaDescription',
    projectDescriptionKey: 'projectsGrid.scapaProjectDescription',
    image: ScapaDeepWaterQuayImage,
    valueKey: 'projectsGrid.scapaValue',
    client: 'Orkney Islands Council',
    FOC: 'NEC4 PSC & NEC4 Option A',
    servicesKey: 'projectsGrid.scapaServices'
  },
  {
    id: 'clashindarroch-ii-wind-farm',
    titleKey: 'projectsGrid.clashindarrochIITitle',
    descriptionKey: 'projectsGrid.clashindarrochIIDescription',
    projectDescriptionKey: 'projectsGrid.clashindarrochIIProjectDescription',
    image: ClashindarrochIIImage,
    valueKey: 'projectsGrid.clashindarrochIIValue',
    client: 'Vattenfall',
    FOC: 'Not Disclosed',
    servicesKey: 'projectsGrid.clashindarrochIIServices'
  },
  {
    id: 'cloiche-wind-farm',
    titleKey: 'projectsGrid.cloicheTitle',
    descriptionKey: 'projectsGrid.cloicheDescription',
    projectDescriptionKey: 'projectsGrid.cloicheProjectDescription',
    image: CloicheWindFarmImage,
    valueKey: 'projectsGrid.cloicheValue',
    client: 'SSE',
    FOC: 'NEC3 PSC',
    servicesKey: 'projectsGrid.cloicheServices'
  }
];


function ProjectsGrid() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const navigate = useNavigate();

  const handleLearnMoreClick = (projectId) => {
    navigate(`/projects/${projectId}`);
  };

  return (
    <div ref={ref} className={`projects-grid-content ${inView ? 'fade-in' : ''}`}>
      <Grid container spacing={4}>
        {projectsData.map((project, index) => (
          <Grid item xs={12} sm={6} md={6} key={index}>
            <Box className="projects-grid-card">
              <Box className="projects-grid-image-container">
                <img src={project.image} alt={t(project.titleKey)} className="projects-grid-image" />
              </Box>
              <Box className="projects-grid-content-box">
                <Typography variant="h6" className="projects-grid-content-title">
                  {t(project.titleKey)}
                </Typography>
                <Typography variant="body2" className="projects-grid-description">
                  {t(project.descriptionKey)}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className="projects-grid-button"
                  onClick={() => handleLearnMoreClick(project.id)}
                >
                  {t('projectsGrid.learnMore')}
                </Button>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default ProjectsGrid;
